import { setTokenGetter } from '@/lib/auth-token';
import { posthog } from '@/lib/posthog';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

export function AuthTokenSync() {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      setTokenGetter(() => getAccessTokenSilently());
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && user) {
      posthog.identify(user.sub, {
        email: user.email,
        name: user.name,
      });
    }
  }, [isAuthenticated, user]);

  return null;
}
